import React, { useEffect, useState } from "react";
import { DashboardShell } from "@/components/DashboardLayout";
import { BackButton } from "@/components/Layout";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { api, fmtSASTDateTime } from "@/lib/api";

export default function AdminSms() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/admin/sms-logs").then(({ data }) => setLogs(data.logs || [])); }, []);
  return (
    <DashboardShell role="admin">
      <BackButton to="/admin" />
      <p className="text-xs tracking-[0.22em] uppercase font-bold text-[#00C4B4]">SMS notifications</p>
      <h1 className="font-display mt-2 text-3xl font-bold text-[#0A2540]">SMS log ({logs.length})</h1>
      <p className="text-sm text-[#666666] mt-1">Currently MOCKED — messages are written to the database for QA. Swap in a live provider (Twilio etc.) later via the SMS framework.</p>
      <div className="mt-6 bg-white border border-[#E5E7EB] rounded-2xl overflow-x-auto">
        <Table data-testid="sms-table">
          <TableHeader><TableRow><TableHead>Timestamp</TableHead><TableHead>To</TableHead><TableHead>Type</TableHead><TableHead>Status</TableHead><TableHead>Message</TableHead></TableRow></TableHeader>
          <TableBody>
            {logs.length === 0 && <TableRow><TableCell colSpan={5} className="text-center py-8 text-[#666666]">No SMS yet</TableCell></TableRow>}
            {logs.map((l) => (
              <TableRow key={l.id}>
                <TableCell className="text-xs whitespace-nowrap">{fmtSASTDateTime(l.created_at)}</TableCell>
                <TableCell className="text-xs font-mono">{l.to}</TableCell>
                <TableCell className="text-xs uppercase">{l.type}</TableCell>
                <TableCell><Badge className="border bg-orange-50 text-orange-700 border-orange-200">{l.status}</Badge></TableCell>
                <TableCell className="text-xs max-w-md">{l.message}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </DashboardShell>
  );
}
